<template>
  <div class="form-group">
    <div class="list-collapse">
      <label :class="{'confirm':!this.edit}">お子様情報（性別、誕生年月） <span
                                          class="list-group list-collapse-trigger"
                                          style="display: inline-block"
                                          :class="{ 'is-active': isOpen}"
                                          @click="toggleChildInfo"
                                        ><i class="fas fa-chevron-down"></i>
                                        </span>
      </label>

      <div>
        <ul class="list-group">
          <li
            ref="accordion"
          >
            <div
              class="list-collapse-body list-group-detail"
              :style="{ height: accordionHeight }"
            >
              <ChildInfoRow
                v-for="(child, idx) in childInfo"
                :edit="edit"
                :count="idx+1"
                :child="child"
                :update="update"
                :key="idx"
              />
            </div>
          </li>
        </ul>
      </div>
      <FormError :errors="errors['account.child'] || []" />
    </div>
  </div>
</template>

<script>
import FormError from '@/components/FormError.vue'
import ChildInfoRow from '@/components/ChildInfoRow'

export default {
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: () => false
    },
    childInfo: {
      type: Array,
      required: true
    },
    update: {
      type: Function,
      required: false
    },
    errors: {
      type: [Array, Object],
      required: false,
      default: () => { return [] }
    }
  },
  data() {
    return {
      isOpen: false,
      accordionHeight: ''
    }
  },
  components: {
    FormError,
    ChildInfoRow
  },
  methods: {
    toggleChildInfo() {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.slideDown()
      } else {
        this.slideUp()
      }
    },
    slideDown() {
      const targetMaxHeight = this.$refs.accordion.children[0].clientHeight
      let targetHeight = 0
      const heightPerTime = targetMaxHeight / 50
      const slideDown = () => {
        const slideDownTimer = setInterval(() => {
          targetHeight += heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight >= targetMaxHeight) {
            clearInterval(slideDownTimer)
            this.accordionHeight = 'auto'
          }
        }, 5)
      }
      slideDown()
    },
    slideUp() {
      let targetHeight = this.$refs.accordion.children[0].clientHeight
      const heightPerTime = targetHeight / 50
      const slideUp = () => {
        const slideUpTimer = setInterval(() => {
          targetHeight -= heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight <= 0) {
            clearInterval(slideUpTimer)
            this.accordionHeight = 0
          }
        }, 5)
      }
      slideUp()
    }
  }
}
</script>
